import ReactHtmlParser from "html-react-parser";

export function htmlParser(html) {
  if (!html) return "";
  return ReactHtmlParser(html);
}
